export default __webpack_public_path__ + "b297df793fb73e678abdbbbc483d2b9c.png";